import { Component, EventEmitter, Output } from "@angular/core";
import { fadeInOut } from "src/app/animations/animations";

@Component({
  selector: "app-instructions",
  templateUrl: "./instructions.component.html",
  styleUrls: ["./instructions.component.scss"],
  animations: [fadeInOut],
})
export class InstructionsComponent {
  @Output() onRoute = new EventEmitter<void>();

  constructor() {}

  changeRoute() {
    this.onRoute.emit();
  }
}
